import { useState } from 'react';
import { Button, Field, Input, Notice } from '../components/ui';
import { useAuth } from '../auth/AuthContext';

/**
 * The Master Admin sign-in.
 *
 * Its own page on its own site, and its own endpoint behind it: one that
 * answers only for a super admin, so an ordinary admin's email and password
 * get the same "incorrect" here as a stranger's.
 */
export function MasterLogin() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await signIn(email.trim(), password);
    } catch (err) {
      setError((err as Error).message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login">
      <form className="login__card" onSubmit={submit}>
        <div className="login__brand">
          <img src="/logo.png" alt="ISawBazaar" />
          <div className="login__rule" />
          <div className="login__title">Master Admin</div>
          <div className="login__sub">Restricted access. Every sign-in attempt is recorded.</div>
        </div>

        <div className="stack">
          {error && <Notice tone="danger">{error}</Notice>}

          <Field label="Email">
            <Input
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              autoFocus
            />
          </Field>

          <Field label="Password">
            <Input
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </Field>

          <Button variant="primary" type="submit" loading={busy} disabled={!email || !password}>
            Sign in
          </Button>
        </div>
      </form>
    </div>
  );
}
